const colors = {
	tprimary: '#bd3531', // primary red
	tsecondary: '#fff', // white - bg
	ttertiary: '#23262d', //
	tgray: '#9d9fa6', // light gray
	snooker: '#0a6c03',
};

export default colors;
